import _ from 'lodash';
import { linkShape } from './utils';

export default function footerNav() {
  return {
    _id: false,
    type: 'droplet.footerNav',
    links: _.times(2, linkShape()),
    linkAligned: 'left',
    mediaQueries: [
      {
        selector: '.drzFooterNav-list-topLink, .drzFooterNav-list-subLink',
        properties: [
          {
            property: 'color',
            desktop: 'rgba(0, 0, 0, 0.7)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    activeLink: null,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/footer-nav/droplet.schema.js